const avatarUrl =
  'https://cdn-icons.flaticon.com/png/512/3177/premium/3177440.png?token=exp=1638549042~hmac=acc62bec47f9ca5fd843f3486cece0d5';

export { avatarUrl };
